import axios from 'axios';
import { ApiError } from './error';

// The Product Improvement credits notice (components/PipCredits): tells a
// company admin once when their company has PIP credits they haven't been
// told about. See backend domain/pip_credits.
const url = '/api/v1/pip-credits';

const data = res => res.data.data;

// → { notice: { kind: 'welcome' | 'more', total, used, available, added } | null }
export const fetchPipCreditsNotice = () => axios.get(`${url}/notice`).then(data).catch(ApiError.ofAndThrow);

// The admin closed it, however they closed it.
export const markPipCreditsSeen = () => axios.post(`${url}/notice/seen`).then(data).catch(ApiError.ofAndThrow);

// Demo/QA: forget the notice and the PIP's tour for this admin.
export const resetPipCredits = () => axios.post(`${url}/reset`).then(data).catch(ApiError.ofAndThrow);
